module.exports = {
      id: "album-usage",
      viewBox: "0 0 25.602 21.762",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#album",
      toString: function () {
        return this.url;
      }
    }